
import { defineComponent, ref, toRaw } from 'vue';
import { useRoute } from 'vue-router';
import {
  getLogInfo,
} from '@/api/message-center';
import type { ILogInfoRes } from '@/api/message-center/type.d';
import MonacoEditor from '@/components/monaco-editor/index.vue';
import { formatTime } from '@toy/utils';

export default defineComponent({
  components: {
    MonacoEditor,
  },
  setup() {
    const $route = useRoute();
    const logId = $route.params.logId as string;

    const logDetail = ref({} as ILogInfoRes);

    const getLogDetail = async () => {
      const { data } = await getLogInfo(logId);
      logDetail.value = data;
    };

    const logDetailKeyMap = {
      messageId: {
        label: '消息ID',
      },
      taskId: {
        label: '任务ID',
      },
      status: {
        label: '消息状态',
      },
      executeService: {
        label: '执行服务',
      },
      logType: {
        label: '日志类型',
      },
      startTime: {
        label: '消费开始时间',
        formatter: (value: string) => formatTime(value),
      },
      executeTime: {
        label: '执行时间',
        formatter: (value: string) => formatTime(value),
      },
      // logContent: {
      //   label: '日志内容',
      // },
      createdTime: {
        label: '创建时间',
        formatter: (value: string) => formatTime(value),
      },
    };

    const detailDialogInfo = ref({
      visible: false,
      value: '',
      title: '',
    });
    const handleShowDetail = (key: keyof ILogInfoRes, title: string) => {
      let value = toRaw(logDetail.value[key]);
      if (typeof value !== 'string') {
        try {
          value = JSON.stringify(value);
        } catch (e) {
          value = '';
          console.error(e);
        }
      }
      detailDialogInfo.value.visible = true;
      detailDialogInfo.value.value = value;
      detailDialogInfo.value.title = title;
    };

    const init = () => {
      getLogDetail();
    };
    init();

    return {
      logDetail,
      logDetailKeyMap,
      detailDialogInfo,
      handleShowDetail,
    };
  },
});
